import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import dayjs from "dayjs";

//internal import
import EmployeeTrackService from "../services/EmployeeTrackService";
import { allContext } from "../context/AllContext";
import { notifySuccess, notifyError } from "../utils/toast";

const useEmployeeTrackSubmit = (id) => {

  const { register, handleSubmit, setValue, reset, formState: { errors } } = useForm();

  const { pageLoading, setPageLoading, dataUpdate, setDataUpdate } = useContext(allContext);

  const [isModal, setIsModal] = useState(false);
  const [isViewModal, setIsViewModal] = useState(false);
  const [isDeleteModal, setIsDeleteModal] = useState(false);
  const [viewData, setviewData] = useState([]);


  // add and update employeeTrack details
  const onSubmit = async (data) => {

    setPageLoading(true);
    try {
      const response = id ? await EmployeeTrackService.UpdateEmployeeTrackById(id, data) : await EmployeeTrackService.addEmployeeTrack(data);
      if (response?.success) {
        notifySuccess(response.message);
        setIsModal(false);
        setDataUpdate(!dataUpdate);
      }
      else {
        notifyError(response.message);
      }
    } catch (error) {
      console.error(error);
      notifyError("Something went wrong.");
    } finally {
      setPageLoading(false);
    }
  };

  //  delete employeeTrack by id 
  const handleDeleteEmployeeTrack = async (id) => {
    try {
      const response = await EmployeeTrackService.deleteEmployeeTrackById(id);
      if (response.success) {
        notifySuccess(response?.message);
        setDataUpdate(!dataUpdate);
      }
      else {
        notifyError(response?.message);
      }
      setIsDeleteModal(false);
    }
    catch (error) {
      console.error("error", error);
      notifyError("Something want wrong !");
      setIsDeleteModal(false);
    }
  }

  useEffect(() => {
    reset();
    if (id) {
      (async () => {
        try {
          const res = await EmployeeTrackService.getEmployeeTrackById(id);
          const data = res?.data;

          if (res?.success) {
            setviewData(data);
            setValue("employeeId", data.employeeId?._id);
            setValue("date", dayjs(data.date).format("YYYY-MM-DD"));
            setValue("time", data.time);
            setValue("location", data.location);
          }
        } catch (error) {
          console.error("Error fetching employeeTrack data:", error);
        }
      })();
    }
  }, [isModal, id]);

  return {
    register,
    handleSubmit,
    setValue,
    errors,
    onSubmit,
    handleDeleteEmployeeTrack,
    pageLoading,
    isModal,
    setIsModal,
    isViewModal,
    setIsViewModal,
    isDeleteModal,
    setIsDeleteModal,
    viewData,
  }
}

export default useEmployeeTrackSubmit;